import React, { useEffect, useRef, useState } from "react";
import Spinner from "../../components/Spinner";
import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";
import { fetchAdminById } from "../../services/admins";
import AdminProfile from "../../components/AdminProfile";

const AdminProfilePage = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const calledRef = useRef(false);

  const { mutate } = useMutation({
    mutationFn: () => fetchAdminById(),
    onSuccess: (data) => {
      setUserData(data.data.admin);
      setLoading(false);
      toast.success("تم تحويلك لصفحة الشخصية");
    },
    onError: () => {
      setLoading(false);
      toast.error("فشل فتح صفحة الشخصية");
    },
  });

  useEffect(() => {
    if (!calledRef.current) {
      mutate();
      calledRef.current = true;
    }
  }, [mutate]);

  if (loading) return <Spinner />;
  if (!userData) return null;

  return <AdminProfile admin={userData} />;
};

export default AdminProfilePage;
